import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">One Thing Left · Unique Finds for Every Hobby</p>
        <h1>Discover Your Next Passion Project</h1>
        <p className="lede">
          Explore our curated selection of unique, limited-edition products tailored for your favorite hobbies and interests. Whether you're a crafting enthusiast, a gaming aficionado, or a DIY lover, we have something special just for you.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Exclusive Collections</h2>
          <p>
            Browse our limited-edition items that you won't find anywhere else. Each product is carefully selected to inspire creativity and enhance your hobbies.
          </p>
        </article>
        <article>
          <h2>Quality Craftsmanship</h2>
          <p>
            Our products are crafted with care and attention to detail, ensuring that you receive only the best for your projects and interests.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Connect with fellow hobbyists and share your passion. Stay updated on new arrivals and exclusive offers by signing up for our newsletter.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;